module.exports = __webpack_public_path__ + "static/img/qiangsheng.50de5e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qiangsheng.png
// module id = ivbg
// module chunks = 1